enum FeatureFlags {
  chat = 'chat',
}

const ENABLED_FEATURES = import.meta.env.VITE_FEATURES_ENABLED ?? '';

export const isFeatureEnabled = (feature: keyof typeof FeatureFlags) => ENABLED_FEATURES.includes(feature);
